import { createContext, useContext } from 'react';
import { ubikContextEnvDevelopment } from '../../../.ubik-context-env.development';
import { ubikContextEnvProduction } from '../../../.ubik-context-env.production';
import { ubikContextEnvStaging } from '../../../.ubik-context-env.staging';

export type EnvironmentContextType = {
    ENV_QUALAROO_SURVEY_URL: string;
    ENV_TRACKING_ENV: string;
    ENV_LOGOMATION_BASE_URL: string;
    ENV_ASSETS_BASE_URL: string;
    ENV_API_BASE_URL: string;
    ENV_LOGOMAKER_BASE_URL: string;
    ENV_PRODUCT_SERVICE_BASE_URL: string;
    ENV_DOMAIN_SEARCH_URL: string;
};

export const EnvironmentContext = createContext<EnvironmentContextType>(ubikContextEnvProduction);

export function useEnvContext() {
    return useContext(EnvironmentContext);
}

type EnvironmentType = 'development' | 'production' | 'staging';

function isEnvironmentType(environment?: string): environment is EnvironmentType {
    if (typeof environment !== 'string') {
        return false;
    }

    return ['development', 'production', 'staging'].includes(environment);
}

export function getUbikEnvironmentContext(environment?: string): EnvironmentContextType {
    const ubikContextEnvironments: Record<EnvironmentType, EnvironmentContextType> = {
        development: ubikContextEnvDevelopment,
        production: ubikContextEnvProduction,
        staging: ubikContextEnvStaging,
    };

    return ubikContextEnvironments[isEnvironmentType(environment) ? environment : 'production'];
}
